/** 1.3.0 Intake: small pieces the list and a submission's page share (P4's). */
import { AlertTriangle, CalendarClock, Check, CircleDashed, FileText, Film, Image, Music, Subtitles, Upload, X, MinusCircle } from 'lucide-react';
import type { DeliveryItemDTO, ItemKind, ItemState, SubmissionState } from '@prism/contracts';
import { relative, dateTime } from '../../lib/format';

export const SUBMISSION_LABEL: Record<SubmissionState, string> = {
  draft: 'Draft', waiting: 'Waiting', needs_changes: 'Needs changes', accepted: 'Accepted', rejected: 'Rejected', withdrawn: 'Withdrawn', expired: 'Expired',
};
const SUBMISSION_TONE: Record<SubmissionState, string> = {
  draft: 'offline', waiting: 'processing', needs_changes: 'partial', accepted: 'ready', rejected: 'failed', withdrawn: 'offline', expired: 'offline',
};
export function SubmissionState({ state }: { state: SubmissionState }) {
  return <span className={`status ${SUBMISSION_TONE[state]}`} data-testid="intake-state" data-state={state}><span className="dot" />{SUBMISSION_LABEL[state]}</span>;
}

export const ITEM_LABEL: Record<ItemState, string> = { open: 'Not uploaded', uploaded: 'To review', accepted: 'Accepted', rejected: 'Rejected', waived: 'Not needed' };
const ITEM_ICON: Record<ItemState, React.ReactNode> = {
  open: <CircleDashed size={11} />, uploaded: <Upload size={11} />, accepted: <Check size={11} strokeWidth={3} />, rejected: <X size={11} strokeWidth={3} />, waived: <MinusCircle size={11} />,
};
export const KIND_ICON: Record<ItemKind, React.ReactNode> = {
  media: <Film size={13} />, document: <FileText size={13} />, subtitles: <Subtitles size={13} />, image: <Image size={13} />, audio: <Music size={13} />, other: <FileText size={13} />,
};

export function ItemPill({ item }: { item: DeliveryItemDTO }) {
  return (
    <span className={`intake-pill ${item.state}`} title={`${item.label}: ${ITEM_LABEL[item.state]}${item.required ? '' : ' (optional)'}`} data-testid="intake-item-pill" data-state={item.state}>
      {ITEM_ICON[item.state]}<span className="intake-pill-text">{item.label}</span>
    </span>
  );
}

export function Due({ dueAt, overdue }: { dueAt: string | null; overdue: boolean }) {
  if (!dueAt) return <span className="faint">—</span>;
  return (
    <span className={overdue ? 'intake-overdue' : 'muted'} title={dateTime(dueAt)} data-testid={overdue ? 'intake-overdue' : undefined}>
      {overdue ? <AlertTriangle size={11} /> : <CalendarClock size={11} />} {overdue ? 'Overdue ' : ''}{relative(dueAt)}
    </span>
  );
}
